import { request } from './base'

export async function getLogsApi(restaurantId: string, startAt: string, limit: number) {
  const resp = await request(
    `/cms/owners/activity?restaurantId=${restaurantId}&startAt=${startAt}&limit=${limit}`,
    'get'
  )
  return resp?.data
}
